import { jsxs as l, jsx as e } from "react/jsx-runtime";
import g from "react";
import { c as o } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
import { B as E, S as b } from "./Input-s7q1Bymv.js";
import { T as c } from "./Typography-DjQwU5Xn.js";
import { T as N } from "./triangle-alert-BRauxpWT.js";
import { c as T } from "./createLucideIcon-OVU-vHz1.js";
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k = [
  ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ]
], S = T("inbox", k), Y = "No results", Z = "Try adjusting your filters or creating a new item.", I = "Something went wrong", L = "We couldn't load this data. Please try again.", A = ({ size: t = 48, className: r }) => /* @__PURE__ */ e(
  S,
  {
    size: t,
    "aria-hidden": "true",
    className: o(r)
  }
), _ = ({ size: t = 48, className: r }) => /* @__PURE__ */ e(
  N,
  {
    size: t,
    "aria-hidden": "true",
    className: o(r)
  }
), w = ({ size: t = 48, className: r }) => /* @__PURE__ */ l(
  "svg",
  {
    width: t,
    height: t,
    viewBox: "0 0 64 64",
    "aria-hidden": "true",
    className: o("shrink-0", r),
    children: [
      /* @__PURE__ */ e("circle", { cx: "32", cy: "32", r: "30", fill: "hsl(var(--ds-illustration-accent-2))" }),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M20 28h24l-2.4 17.5a2 2 0 0 1-2 1.7H24.4a2 2 0 0 1-2-1.7L20 28Z",
          fill: "hsl(var(--ds-illustration-accent-1))"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M22 28 32 18l10 10",
          stroke: "hsl(var(--ds-illustration-accent-3))",
          strokeWidth: "2.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ e("circle", { cx: "26", cy: "36", r: "2", fill: "hsl(var(--ds-illustration-accent-3))" }),
      /* @__PURE__ */ e("circle", { cx: "38", cy: "36", r: "2", fill: "hsl(var(--ds-illustration-accent-3))" })
    ]
  }
), D = ({ size: t = 48, className: r }) => /* @__PURE__ */ l(
  "svg",
  {
    width: t,
    height: t,
    viewBox: "0 0 64 64",
    "aria-hidden": "true",
    className: o("shrink-0", r),
    children: [
      /* @__PURE__ */ e("circle", { cx: "32", cy: "32", r: "30", fill: "hsl(var(--ds-illustration-accent-1))" }),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M32 18c-6.6 0-12 5.4-12 12v6c0 6.6 5.4 12 12 12s12-5.4 12-12v-6c0-6.6-5.4-12-12-12Z",
          fill: "hsl(var(--ds-illustration-accent-2))"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M32 28v10",
          stroke: "hsl(var(--ds-illustration-accent-3))",
          strokeWidth: "3",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ e("circle", { cx: "32", cy: "44", r: "2", fill: "hsl(var(--ds-illustration-accent-3))" })
    ]
  }
), m = {
  outline: {
    empty: A,
    error: _
  },
  playful: {
    empty: w,
    error: D
  }
}, u = {
  illustration: "playful",
  nature: "playful",
  editorial: "outline",
  brutalist: "outline",
  neumorphism: "outline",
  executive: "outline",
  "glass-luxe": "playful",
  "minimal-contrast": "outline",
  "neo-dark": "outline",
  "aero-mica": "outline",
  retrofuture: "playful",
  "maximal-luxe": "playful"
}, h = "outline", p = {
  style: "editorial",
  theme: "editorial"
}, M = () => {
  if (typeof document > "u")
    return p;
  const t = document.documentElement, r = t.getAttribute("data-theme") || void 0, a = t.getAttribute("data-style") || r || void 0;
  return !a && !r ? p : {
    style: a,
    theme: r
  };
}, R = ({ set: t, style: r, theme: a } = {}) => {
  if (t) return t;
  const s = M(), n = r || s.style, i = a || s.theme;
  return n && u[n] ? u[n] : i && u[i] ? u[i] : h;
}, v = (t, r = {}) => {
  var n;
  const a = R(r), s = m[a] || m[h];
  return (s == null ? void 0 : s[t]) || ((n = m[h]) == null ? void 0 : n[t]) || null;
}, q = ({
  name: t,
  size: r,
  className: a,
  set: s,
  style: n,
  theme: i
}) => {
  const d = v(t, { set: s, style: n, theme: i });
  return d ? /* @__PURE__ */ e(
    d,
    {
      size: r,
      className: a
    }
  ) : null;
}, f = () => /* @__PURE__ */ l("svg", { width: "48", height: "48", viewBox: "0 0 24 24", "aria-hidden": "true", className: "shrink-0", children: [
  /* @__PURE__ */ e("circle", { cx: "12", cy: "12", r: "10", className: "fill-current opacity-20" }),
  /* @__PURE__ */ e("path", { d: "M12 7v6", className: "stroke-current", strokeWidth: "2", strokeLinecap: "round" }),
  /* @__PURE__ */ e("circle", { cx: "12", cy: "16.5", r: "1", className: "fill-current" })
] }), C = ({
  illustration: t,
  illustrationSet: r
}) => {
  try {
    const a = v(t, { set: r });
    return a ? /* @__PURE__ */ e(a, { size: 48 }) : /* @__PURE__ */ e(f, {});
  } catch {
    return /* @__PURE__ */ e(f, {});
  }
};
class j extends g.Component {
  constructor() {
    super(...arguments), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch() {
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ e(f, {}) : this.props.children;
  }
}
const J = ({
  title: t = I,
  description: r = L,
  onRetry: a,
  icon: s,
  illustration: n = "error",
  illustrationSet: i,
  className: d,
  ...y
}) => {
  const x = s ?? /* @__PURE__ */ e(j, { children: /* @__PURE__ */ e(
    C,
    {
      illustration: n,
      illustrationSet: i
    }
  ) });
  return /* @__PURE__ */ l(
    "div",
    {
      className: o(
        "flex flex-col items-center justify-center text-center p-8 rounded-[var(--ds-radius-lg)] border border-destructive/20 bg-destructive/10",
        d
      ),
      role: "alert",
      ...y,
      children: [
        /* @__PURE__ */ e("div", { className: "mb-4 text-destructive", children: x }),
        /* @__PURE__ */ e(c, { variant: "h3", className: "mb-2 text-destructive", children: t }),
        /* @__PURE__ */ e(c, { variant: "body", className: "mb-6 max-w-sm text-destructive/80", children: r }),
        a && /* @__PURE__ */ e(
          E,
          {
            onClick: a,
            variant: "danger",
            children: "Try Again"
          }
        )
      ]
    }
  );
}, Q = ({
  message: t = "Loading...",
  fullScreen: r = !1,
  className: a,
  ...s
}) => /* @__PURE__ */ l(
  "div",
  {
    className: o(
      "flex flex-col items-center justify-center p-8",
      r ? "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm" : "min-h-[200px]",
      a
    ),
    role: "status",
    "aria-live": "polite",
    ...s,
    children: [
      /* @__PURE__ */ e(b, { size: "lg", className: "text-primary mb-4" }),
      /* @__PURE__ */ e(c, { variant: "body", className: "text-muted-foreground", children: t })
    ]
  }
), V = ({
  title: t,
  description: r,
  children: a,
  actions: s,
  className: n,
  ...i
}) => /* @__PURE__ */ l(
  "section",
  {
    className: o(
      "rounded-[var(--ds-radius-lg)] border border-border bg-card shadow-elevation-1",
      n
    ),
    ...i,
    children: [
      (t || r || s) && /* @__PURE__ */ l("div", { className: "flex items-center justify-between border-b border-border px-6 py-4", children: [
        /* @__PURE__ */ l("div", { children: [
          t && /* @__PURE__ */ e(c, { variant: "h4", className: "text-card-foreground", children: t }),
          r && /* @__PURE__ */ e(c, { variant: "body", className: "mt-1 text-muted-foreground", children: r })
        ] }),
        s && /* @__PURE__ */ e("div", { className: "ml-4", children: s })
      ] }),
      /* @__PURE__ */ e("div", { className: "p-6", children: a })
    ]
  }
);
export {
  Y as D,
  J as E,
  q as I,
  Q as L,
  V as S,
  Z as a,
  I as b,
  L as c,
  v as d,
  M as g,
  m as i,
  R as r,
  u as t
};
